'use client';
import { PropsWithChildren } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import { ChevronRightIcon, ExclamationmarkSmallCircleIcon } from '@zep/icons';
import { Colors } from '@zep/ui-tokens';

import S from './index.module.scss';

export const _AppUploadGuide = () => {
  const {
    t,
    i18n: { resolvedLanguage },
  } = useTranslation(['common', 'accounts']);

  const link =
    resolvedLanguage === 'ko'
      ? 'https://docs-kr.zep.us/creator/zep-script-guide/dev-guide/zep-script'
      : 'https://docs.zep.us/zep-script/zep-script-guide/zep-script-development-guide/zep-script-deployment-guide';

  return (
    <div className={S.upload_guide}>
      <div>
        <ExclamationmarkSmallCircleIcon width={20} height={20} />
        {t('accounts:myApp.upload.guideNotice')}
      </div>
      <div>
        <Link href={link} target={'_blank'} prefetch={false}>
          {t('accounts:myApp.upload.guideLink')}
          <ChevronRightIcon
            fill={Colors.PrimaryDefault}
            width={18}
            height={18}
          />
        </Link>
      </div>
    </div>
  );
};

export const MyAppWrapper = (props: PropsWithChildren) => {
  return <div className={S.wrapper}>{props.children}</div>;
};
